import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useCallback } from 'react'
import { InternalLink } from '../../const/Links'
import type { BrandVisualResult } from '../../data/BrandFragment'
import style from './BrandCard.module.sass'

type BrandCardProps = {
	brand: BrandVisualResult
	isBrandNameVisible?: boolean
	closeModal?: () => void
}

export const BrandCard = React.memo(function BrandCard(props: BrandCardProps) {
	const router = useRouter()
	const url = `${InternalLink.Brand}${props.brand.slug}`

	const onClick = useCallback(() => {
		if (props.closeModal) {
			props.closeModal()
		}
		router.push(url)
	}, [props, router, url])

	const content = (
		<>
			<div className={clsx(style.wrapper, props.isBrandNameVisible && style.wrapperWithBrand)}>
				<div className={clsx(style.imageWrapper, !props.brand.logo?.url && style.imageWrapperPlaceholder)}>
					<div className={style.image}>
						<div className={clsx(style.image, !props.brand.logo?.url && style.imagePlaceholder)}>
							<NextImage
								src={props.brand.logo?.url ?? '/images/placeholder-product.png'}
								title={props.brand.name}
								alt={props.brand.name}
								layout="fill"
								objectFit={props.brand.logo?.url ? 'contain' : 'cover'}
							/>
							{!props.brand.logo?.url && (
								<span className={style.imagePlaceholderWrapper}>
									<span className={style.imagePlaceholderTitle}>{props.brand.name}</span>
								</span>
							)}
						</div>
					</div>
				</div>
			</div>
			{props.isBrandNameVisible && <div className={style.title}>{props.brand.name}</div>}
		</>
	)

	if (props.closeModal !== undefined) {
		return (
			<Link className={style.buttonWrapper} onClick={onClick} href={url} title={props.brand.name}>
				<div className={clsx(style.root, props.isBrandNameVisible && style.rootWithBrand)}>{content}</div>
			</Link>
		)
	}
	return (
		<Link
			href={url}
			className={clsx(style.root, props.isBrandNameVisible && style.rootWithBrand)}
			title={props.brand.name}
		>
			{content}
		</Link>
	)
})
